import React, { useEffect } from 'react';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Dialog from '@mui/material/Dialog';
import Footer from '../cards/Footer';
import { getMarkDown, useDetectMobile } from '../utils';
import { ReactComponent as NextArrow } from '../../../assets/NextArrow.svg';
import { ReactComponent as CloseIcon } from '../../../assets/toast-icon-close-gray.svg';
import '../../../stylesheets/triagebot/Dialog.scss';

const ThankYouDialog = ({ isDialogOpen, onClose, onContinue, redirectUrl, headerText, bodyText, buttonText ,closeButton}) => {
    const { isMobile } = useDetectMobile();

    onClose = (typeof onClose === 'function')
        ? onClose
        : () => { }

    onContinue = (typeof onContinue === 'function')
        ? onContinue
        : () => { }

    headerText = headerText || 'Thank you for your feedback';
    bodyText = bodyText || 'You’ve completed the assessment and the survey—we thank you!  Please close this dialog box or learn more about Optum.';
    buttonText = buttonText || (redirectUrl ? 'Go to Optum.com' : 'Continue');

    function getStyle(oElm, strCssRule) {
        var strValue = "";
        if (document.defaultView && document.defaultView.getComputedStyle) {
            strValue = document.defaultView.getComputedStyle(oElm, "").getPropertyValue(strCssRule);
        }
        else if (oElm.currentStyle) {
            strCssRule = strCssRule.replace(/-(\w)/g, function (strMatch, p1) {
                return p1.toUpperCase();
            });
            strValue = oElm.currentStyle[strCssRule];
        }
        return strValue;
    }

    useEffect(() => {
        setTimeout(() => {
            const cards = document.getElementsByClassName('turn');

            if (!cards.length) return;

            const cWidth = cards[cards.length - 1].offsetWidth;
            const dialog = document.querySelector('#change-dialog .MuiDialog-paper');

            if (!dialog) return;

            const padding = parseInt(getStyle(dialog, 'padding-left')) + parseInt(getStyle(dialog, 'padding-right'));

            dialog.style.width = (cWidth - padding) + 'px';
            dialog.style.minWidth = (cWidth - padding) + 'px';
        }, 1)
    })

    const handleClose = () => {
        onClose();
        document.activeElement.blur();
    }

    const handleContinue = () => {
        onContinue();

        // Redirect if URL is provided
        if (redirectUrl) {
            try {
                const url = new URL(redirectUrl);
                window.open(url.toString(), '_blank');
            } catch (error) {
                console.error('Invalid redirect URL:', error);
            }
        }

        setTimeout(() => {
            document.activeElement.blur();
        }, 0);
    }

    return (
        <Dialog
            id='change-dialog'
            open={isDialogOpen}
            onClose={(event, reason) => { if (reason !== 'backdropClick') handleClose(); }}
            aria-labelledby='dialog-title'
            aria-describedby='dialog-body'
            PaperProps={{
                className: !isMobile ? 'open' : ''
            }}
        >
            <div id="dialog-title">
                <div className='thank-you-header-row'>
                    <h2 className='headerText thank-you-header-text'>{getMarkDown(headerText)}</h2>
                    <button
                        type='button'
                        className='close-icon'
                        aria-label='Close dialog'
                        onClick={handleClose}
                    >
                        <CloseIcon />
                    </button>
                </div>
            </div>

            <DialogContent dividers id="dialog-body" className='thank-you-dialog-body'>
                {getMarkDown(bodyText)}
            </DialogContent>

            <DialogActions id="dialog-footer" className='thank-you-dialog-footer'>
                <Footer>
                    <button
                        className={isMobile ? 'mobile cancel-button' : 'cancel-button'}
                        onClick={handleClose}
                    >
                        {closeButton}
                    </button>
                    <button
                        className='continue-button thank-you-continue-button'
                        onClick={handleContinue}
                    >
                        {redirectUrl ? (
                            <span style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                <span>{buttonText}</span>
                                <NextArrow className='next-option-arrow' style={{ width: isMobile ? '30px' : '20px', height: isMobile ? '30px' : '20px', display: 'inline-block' }} />
                            </span>
                        ) : buttonText}
                    </button>
                </Footer>
            </DialogActions>
        </Dialog>
    )
};

export default ThankYouDialog;
